import { Power2, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const rotateInB: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      duration: 0,
      opacity: 0,
      scale: 3,
      rotateZ: 720,
      transformOrigin: '50% 50%',
      ease: Power2.easeOut,
    },
    {
      duration: 1,
      opacity: 1,
      scale: 1,
      rotateZ: 0,
      transformOrigin: '50% 50%',
      ease: Power2.easeOut,
    }
  );
};
